import { defineComponent } from "vue";

import ImplantableDeviceSection from "./ImplantableDeviceSection/ImplantableDeviceSection.vue";
import ClinicalHistorySection from "./ClinicalHistorySection/ClinicalHistorySection.vue";
import Immunization from "./Immunization/Immunization.vue";

export default defineComponent({
    components: {
        ClinicalHistorySection,
        ImplantableDeviceSection,
        Immunization
    }
});
